<template>
  <div class="container page">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
      <template #right>
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{$t("withdraw.with_record")}}</span>
      </template>
    </van-nav-bar>

    <!-- 主体内容 -->
    <div class="main">
      <!-- 白色表单卡片 -->
      <div class="form-card">
        <div class="form-row">
          <span class="label">{{$t('setting.username')}}</span>
          <span class="value">{{ bankInfo.username }}</span>
        </div>
        <div class="form-row">
          <span class="label">{{ $t("my.balance") }}</span>
          <span class="value">{{ userInfo.money }}</span>
        </div>
        <div class="form-row">
          <span class="label">{{$t('setting.band_account')}}</span>
          <span class="value">{{ bankInfo.bankid }}</span>
        </div>
        <div class="form-row">
          <span class="label">{{$t('withdraw.with_money')}}</span>
          <div class="value-right">
            <van-field
              v-model="withdraw_money"
              type="number"
              :placeholder="$t('withdraw.with_money')"
              class="money-input"
              input-align="right"
            />
            <div class="hint" @click="withdraw_money = userInfo.money" style="cursor:pointer;">
              <p>{{$t("withdraw.low")}}{{this.withdrawRole.min}}  {{$t("index.all")}}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 提交按钮 -->
      <van-button class="submit-btn" @click="doWithdraw()">
        {{$t("withdraw.with_center")}}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPopover: false,
      withdraw_money: "",
      userInfo: {},
      bankInfo: {},
      withdrawRole: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.bankInfo = res.data.info;console.log(res.data.info);
          } else {
            this.$router.push({ path: '/BindCard' });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserWithdrawRole() {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res => {
        if (res.code === 200) {
          this.withdrawRole = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    doWithdraw() {
      if (this.withdraw_money <= 0) {
        this.$toast(this.$t("setting.correct_money"));
        return false;
      } else {
        this.$http({
          method: 'post',
          data: { money: this.withdraw_money },
          url: 'user_set_withdraw'
        }).then(res => {
          if (res.code === 200) {
            location.reload();
            this.$toast(res.msg);
            this.getUserInfo();
            this.getUserWithdrawRole();
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        });
      }
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
      this.getUserWithdrawRole();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
.page {
  min-height: 100VH;
  background: #f7f8fa;
}

/* 顶部导航栏 - 浅紫渐变背景 */
.nav-bar {
  background: #8600ff !important;
  :deep(.van-nav-bar__title) {
    color: #fff;
    font-size: 18PX;
    font-weight: bold;
  }
  :deep(.van-nav-bar__text) {
    color: #fff;
  }
}

.nav-right {
  font-size: 14PX;
  color: #fff;
}

/* 主体内容 */
.main {
  padding: 20PX 15PX;
}

/* 白色表单卡片 */
.form-card {
  background: #fff;
  border-radius: 12PX;
  padding: 10PX 15PX;
  margin-bottom: 30PX;
  box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.05);
}

.form-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18PX 0;
  border-bottom: 1PX solid #f5f5f5;
}

.form-row:last-child {
  border-bottom: none;
}

.label {
  font-size: 15PX;
  color: #666;
}

.value {
  font-size: 15PX;
  color: #333;
  font-weight: 500;
}

.value-right {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

/* 金额输入框 */
.money-input {
  padding: 0;
  background: transparent;
  font-size: 16PX;
  color: #333;
  font-weight: 500;
  :deep(.van-field__control) {
    font-size: 16PX;
    color: #333;
    font-weight: 500;
  }
}

.hint {
  font-size: 13PX;
  color: #999;
  margin-top: 4PX;
}

/* 提交按钮 */
.submit-btn {
  width: 100%;
  height: 50PX;
  border-radius: 25PX;
  background: linear-gradient(90deg, #ff5f6d, #ff2d55) !important;
  color: #fff;
  font-size: 16PX;
  font-weight: bold;
  border: none;
}

.submit-btn::after {
  border: none;
}
::v-deep .van-field__control {
  font-size: 14PX;line-height: 32PX;
  color: #333;
}

/* 修改 placeholder 字体大小 */
::v-deep  .van-field__control::placeholder {
  font-size: 14PX;line-height: 32PX;
  color: #999;
}
</style>